// YunSharpFlat.js
import {
    useState,
    // useEffect,
    useRef
} from 'react';

import './YunSharpFlat.css';
import YunSection from '../YunSection/YunSection'
import YunIcon from '../YunIcon/YunIcon';

import { openWindow } from '../../../utils/index';

const YunSharpFlat = function YunSharpFlat(props) {
    const {
        sharpFlatState,
        setSharpFlatState,
        setSharpFlatValue,
        updateSharpFlatValue,
        pageset,
        // playerData,
        // updateKeyNoteByTune,
        setPluginTipDiaState,
    } = props
    const sliderConfig = {
        step: 1,
        min: -6,
        max: 6,
    }
    const [isInit, setIsInit] = useState(false);
    const [showMask, setShowMask] = useState(false);
    const [showTipDialog, setShowTipDialog] = useState(false); // 控制提示弹框显示
    const lastCallTime = useRef(0); // 记录上次调用时间

    // useEffect(() => {
    //     window.onPlayerToneChange = (tone, player) => {
    //         console.log('onPlayerToneChange===========', tone, player);
    //         if (playerData.player === "wesing" && player === "wesing") {
    //             updateKeyNoteByTune(tone)
    //         }
    //     }
    // }, [playerData, updateKeyNoteByTune]);

    // 初始化一次  每次启动在升降调插件连接之后将升降调初始化为0
    if (!isInit && sharpFlatState.online) {
        updateSharpFlatValue(0)
        setIsInit(true)
    }

    const showPluginTipDia = () => {
        // 节流调用新方法：第一次立即触发，后续5秒内不执行，超过5秒才会执行
        const now = Date.now();
        if (now - lastCallTime.current > 5000) {
            // 超过3秒或第一次调用，立即执行
            setPluginTipDiaState({
                isVisible: true,
                pluginName: "升降调"
            })
            lastCallTime.current = now;
        }
    }

    // 格式化升降调显示
    function getTextValue(value) {
        return value <= 0 ? value : '+' + value;
    }
    // 加减升降调值
    function clickSetSharpFlatValue(num) {
        showPluginTipDia()
        if (!sharpFlatState.online) {
            setShowMask(true)
            setTimeout(() => {
                setShowMask(false)
            }, 5000);
            return false
        }
        let value = sharpFlatState.value + num
        if (value < sliderConfig.min) {
            value = sliderConfig.min
        } else if(value > sliderConfig.max) {
            value = sliderConfig.max
        }
        setSharpFlatState({
            value: value,
        })
        if (sharpFlatState.isSwitch) {
            setSharpFlatValue(value, true);
        }
    }
    // 跳转到升降调设置页面
    function clickToSettingPage() {
        openWindow(window.location.origin + window.location.pathname + '#/sharpflat');
    }
    if (!pageset.sharpFlat) {
        return null;
    }
    return (
        <div className="YunSharpFlat YunComponent">
            <YunSection width="200" height="33">
                <div className="YunSectionLayout">
                    <div className="Left">
                        <p className="Label">升降调：</p>
                    </div>
                    <div className="Middle">
                        <div className="YunBtn" onClick={() => {clickSetSharpFlatValue(-1)}}>
                            <YunIcon icon="icon_sub"></YunIcon>
                        </div>
                        <span className="Value">{getTextValue(props.sharpFlatState.value)}</span>
                        <div className="YunBtn" onClick={() => {clickSetSharpFlatValue(1)}}>
                            <YunIcon icon="icon_add"></YunIcon>
                        </div>
                    </div>
                    <div className="Right">
                        <p onClick={clickToSettingPage} className="SubLabel UnderlineAnimation HoverColor MainColor">伴 奏</p>
                    </div>
                </div>
                {/* 酷狗音效提示弹框 */}
                {showTipDialog && (
                    <div className="TipDialog">
                        <div className="TipDialogContent">
                            <div className="TipText">检测到酷狗音效已开启，升降调效果可能不生效</div>
                            <div className="TipClose" onClick={() => setShowTipDialog(false)}>×</div>
                        </div>
                    </div>
                )}
                <div className={showMask ? 'Mask Active' : 'Mask'} onClick={clickToSettingPage}>
                    <div className="MaskText">
                        <span className="UnderlineAnimation HoverColor MainColor">未连接</span>
                        <span>升降调插件 </span>
                        <YunIcon icon="click" iconClass="HoverColor MainColor"></YunIcon>
                        <span>设置</span>
                    </div>
                </div>
            </YunSection>
        </div>
    )
}
export default YunSharpFlat;
